import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const bookerPeriodManagementRoute: RouteConfig<'with-page'> = {
    name: 'Manage Period',
    path: '/booker/periods/:periodId',
    page: lazy(() => import('.')),
    flags: ['work-in-progress', 'no-menu-item'],
}